document.addEventListener('click', function(e) {
  const atcBtn = e.target.closest('button[name="add"]');
  if (!atcBtn) return;
  const card = document.querySelector('#turkish-coffee-card');
  if (!card || !card.classList.contains('tc-selected')) return;
  
  card.classList.remove('tc-selected');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: 47104381681815, quantity: 1 })
  });
});